<app-programtitle title="Billing app"></app-programtitle>
<p> Write a billing application which takes products purchased, quantity, price and calculate the total amount to pay.</p>

<app-editor code="{{program}}"> </app-editor>